@import 'styles/mixins';
@import 'styles/variables';

.antdOverride {
  @include z-index(antdPopover);

  :global .ant-popover-inner-content {
    padding: 0;
  }

  :global .ant-popover-arrow {
    display: none;
  }
}

.positionContainer {
  @include z-index(table);
  position: fixed;
}

.contentContainer {
  background: $white;
  border: 1px solid $gray-20;
  @include shadow-3;
  border-radius: 8px;
  padding: 6px 8px;
}

.sectionTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $gray-40;
  padding: 8px;
}

.menuItem {
  padding: 8px;
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  color: $gray-90;
  @include ui-md-text;
  margin: 2px;

  &:hover {
    background: $gray-5;
  }

  span {
    margin-left: 10px;
  }
}

.menuItemIcon {
  fill: $grey-30;
}

.menuItemChevron {
  margin-left: auto;
}

.divider {
  margin: 4px 6px;
  height: 1px;
  background: $gray-20;
}
